export const STORAGE_TOKEN_NAME = 'token';
export const STORAGE_CURRENT_COURSE_NAME = 'currentCourse';
export const SYNC_DATE = 'ig:syncDate';
export const COURSE_DOWNLOADED = 'ig:courseDownloaded';

export const COMMON_NS = 'common';
